import { render, staticRenderFns } from "./PartyDetailsResponsesTab.vue?vue&type=template&id=29a8fb8e"
import script from "./PartyDetailsResponsesTab.vue?vue&type=script&lang=js"
export * from "./PartyDetailsResponsesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports